import { useStyles } from "./BundleAvatarSession.style";
import { Button, Typography, TypographyVariant } from "@onmo/ui";
import { Inventory, InventoryAvatarData } from "@onmo/graphql/graphql";
import { meGQL } from "../../../graphql";
import ShopAvatar from "../../core/ShopAvatar/ShopAvatar";
import { useFetchAvatarsByBundle } from "../../../hooks/resolvers/useShopQuery";
import { useQuery } from "@apollo/client";
import ShopAvatarLoading from "../../core/ShopAvatar/ShopAvatarLoading";
import { useTranslation } from "react-i18next";

type IBundleAvatarSessionProps = {
  bundleId: string;
  title?: string;
  onOpenBundle?: () => void;
};

const BundleAvatarSession: React.FC<IBundleAvatarSessionProps> = (props) => {
  const classes = useStyles();
  const { bundleId, title, onOpenBundle } = props;
  const { avatarsByBundleAvailable, avatarsByBundle } =
    useFetchAvatarsByBundle(bundleId);
  const { data: dataMe } = useQuery(meGQL);
  const { t } = useTranslation();

  return (
    <div className={classes.tabContent}>
      {title && (
        <div className={classes.tabTitle}>
          <Typography
            variant={TypographyVariant.HeadingH6Bold}
            className={classes.title}
          >
            {title}
          </Typography>
          <Button
            size="small"
            variant="outlined"
            icon="icon-box-add"
            onClick={onOpenBundle}
          >
            {t("bundle")}
          </Button>
        </div>
      )}
      <div className={classes.listAvatars}>
        {!avatarsByBundle
          ? Array.from(new Array(5)).map((_, idx) => (
              <ShopAvatarLoading key={idx} />
            ))
          : (title ? avatarsByBundleAvailable : avatarsByBundle)?.map(
              (item: Inventory) => {
                return (
                  <ShopAvatar
                    inventory={item}
                    isUsing={
                      (item?.data as InventoryAvatarData).url ===
                      dataMe?.me.avatar
                    }
                  />
                );
              },
            )}
      </div>
    </div>
  );
};
export default BundleAvatarSession;
